import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NSDiversionsConstants } from '@ruby/configs/diversions.constants';
import {
  DiversionsRequestDetailActions,
  DiversionsRequestDetailSelectors,
  fromDiversionsRequestDetail
} from '@ruby/modules/diversions/store/diversions-request-detail.index';
import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';
import { IDiversionsEventHistory } from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-event-history-dialog-container',
  templateUrl: './event-history-dialog.container.html',
  styleUrls: ['./event-history-dialog.container.scss']
})
export class EventHistoryDialogContainer implements OnInit {
  configs: IGridConfigurations = NSDiversionsConstants.eventsGridConfigsGridConfigs;
  store$: Observable<fromDiversionsRequestDetail.State>;
  events: Array<IDiversionsEventHistory> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      customerNumber: string;
      customerSequence: string;
      carId: string;
      requestNumber: string;
    },
    private store: Store<fromDiversionsRequestDetail.State>) {
    this.store$ = this.store.select(DiversionsRequestDetailSelectors.selectDiversionsRequestDetailState);
  }

  ngOnInit(): void {
    this.dispatch(this.data.customerSequence);
  }

  private dispatch(customerSequence: string) {
    this.store.dispatch(
      DiversionsRequestDetailActions.loadEventHistory({
        data: {
          customerNumber: this.data.customerNumber,
          customerSequence
        }
      })
    );
  }
}
